import { inject, Injectable } from '@angular/core';
import {
    ParkingAndOtherSalesCommissionEndpoints,
    ParkingSalesEndpoints,
} from 'app/core/enums/endpoints';
import { DeleteSaleBody } from 'app/core/interfaces/finances';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ParkingSalesService {
    private _endpoint = ParkingSalesEndpoints;
    private _commissionEndps = ParkingAndOtherSalesCommissionEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // --------------------------------------------------------------------------
    // @ Public methods
    // --------------------------------------------------------------------------
    // --------------------------------------------------------------------------
    // @ CRUD methods
    // --------------------------------------------------------------------------

    getAll(playdateId: number, locationId?: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    // getOne(id: number): Observable<any> {
    //     return this._apiService.getOne(this._endpoint.getOne, id);
    // }

    create(data: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: string, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.patch, data, id);
    }

    delete(data: DeleteSaleBody): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, data);
    }

    /**
     * @description
     * Get parking sales commissions
     * @returns
     */
    getCommissions(playdateId: number): Observable<any> {
        return this._apiService.getOneWithQueryParams(
            this._commissionEndps.getAll,
            playdateId,
            {
                play_date_id: playdateId,
                departure: 'Parking',
            }
        );
    }
}
